import React from "react";
import { LeadFormSection } from "@modules/elearning/lead/components";
import { Grid } from "@mui/material";
import { getAssets } from "@unisearch/helpers";
import { ReactSVG } from "react-svg";
import styles from "./../lead_page.module.scss";

export const DailyIdiomsPhrases = () => {
  return (
    <>
      <section className={styles.section_hero}>
        <div className="container">
          <Grid container spacing={{ xs: 3, sm: 3, md: 6 }} alignItems="center">
            <Grid item xs={12} sm={6} md={6}>
              <div className={styles.heading_wrapper}>
                <h1 className={`${styles.heading} ${styles.custom_heading}`}>
                  Band 8+ IELTS Speaking{" "}
                  <span className={"mark color-orange"}>Masterclass</span> Daily
                  Usage Idioms and Phrases
                </h1>
                <p className={`${styles.sub_text} ${styles.custom_subtext}`}>
                  After attending this one-hour masterclass, you will feel
                  equipped and ready for IELTS Speaking with an ample repertoire
                  of idioms, phrases, and vocabulary! This class will teach you
                  the proper application of some commonly-used lexical
                  resources, followed by some short exercises to help you hit
                  your target Band 8 score.
                </p>

                {/* <div className={styles.pricing_wrapper}>
                  <span className={styles.price_deleted}>₹ 10,000/</span>-
                  <span className={`color-orange`}> ₹499</span>
                  <div className={`${styles.price_text} color-orange`}>
                    Pay After Your First Class
                  </div>
                </div> */}

                <div className={styles.btn_wrapper}>
                  <a href={"#form"} className={`btn btn-secondary btn-xl`}>
                    Book Now
                  </a>
                </div>
              </div>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <div className={styles.hero_image_wrapper}>
                <img
                  src={getAssets(
                    "/assets/images/elearning/lead/daily-usage-idioms-phrase.png"
                  )}
                  alt="target ielts score"
                />
              </div>
            </Grid>
          </Grid>
        </div>
      </section>
      {/* Highlights section */}
      <section className={styles.section_onlinetest}>
        <div className="container">
          <h2 className={styles.title}>
            Program <span className={"color-orange"}>Highlights</span>
          </h2>
          <Grid container spacing={{ xs: 3, sm: 3, md: 4 }}>
            <Grid item xs={12} sm={6} md={3}>
              <div className={`${styles.test_card} ${styles.test_card_1}`}>
                <img
                  className={styles.test_card_corner}
                  src={getAssets(
                    "assets/images/elearning/lead/corner-green.png"
                  )}
                  alt="ornament"
                />
                <ReactSVG
                  className={styles.test_icon}
                  src={getAssets("assets/images/elearning/power-button.svg")}
                />
                <h4 className={styles.test_title}>Start Now, Pay Later</h4>
                <div className={styles.test_desc}>
                  To make your target IELTS scores more accessible than ever, we
                  want to get you started right away. Sit for your first class
                  before you pay your registration fee.
                </div>
              </div>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <div className={`${styles.test_card} ${styles.test_card_2}`}>
                <img
                  className={styles.test_card_corner}
                  src={getAssets(
                    "assets/images/elearning/lead/corner-violet.png"
                  )}
                  alt="ornament"
                />
                <ReactSVG
                  className={styles.test_icon}
                  src={getAssets("assets/images/elearning/training.svg")}
                />
                <h4 className={styles.test_title}>
                  Certified IELTS Trainer with Proven Success Rate
                </h4>
                <div className={styles.test_desc}>
                  Get the insider insight you need to score better in your
                  IELTS, from trainers with years of experience coaching
                  students to achieve their dream scores.
                </div>
              </div>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <div className={`${styles.test_card} ${styles.test_card_3}`}>
                <img
                  className={styles.test_card_corner}
                  src={getAssets(
                    "assets/images/elearning/lead/corner-orange.png"
                  )}
                  alt="ornament"
                />
                <ReactSVG
                  className={styles.test_icon}
                  src={getAssets(
                    "assets/images/elearning/desk-chair-orange.svg"
                  )}
                />
                <h4 className={styles.test_title}>Limited Seats</h4>
                <div className={styles.test_desc}>
                  Giving each student the attention and support they need is
                  UniSearch’s top priority - we stick to smaller batches to
                  ensure every individual receives personalized guidance.
                </div>
              </div>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <div className={`${styles.test_card} ${styles.test_card_4}`}>
                <img
                  className={styles.test_card_corner}
                  src={getAssets(
                    "assets/images/elearning/lead/corner-blue.png"
                  )}
                  alt="ornament"
                />
                <ReactSVG
                  className={styles.test_icon}
                  src={getAssets("assets/images/elearning/diamond.svg")}
                />
                <h4 className={styles.test_title}>
                  Exclusively Official Content
                </h4>
                <div className={styles.test_desc}>
                  Our trainers exclusively use study materials designed by the
                  official test administrators to give you real experience in
                  how to ace the actual exam.
                </div>
              </div>
            </Grid>
          </Grid>
        </div>
      </section>

      {/* Form Section */}
      <LeadFormSection
        subject={"Band 8+ IELTS Speaking Masterclass"}
        subjectHTML={`
            <div
              style="
                font-size: 22px;
                font-weight: 600;
                line-height: 36px;
                padding: 0 50px;
                text-align: center;
                margin: 0 !important;
              "
            >
              Your Registration was Successful | IELTS
              <span style="color: #f47f20">Masterclass</span> by UniSearch
            </div>
        `}
        bodyHTML={`
            <div style="padding: 0 50px; font-size: 12px">
              <p style="line-height: 1.8">Dear --NAME--,</p>
              <p style="line-height: 1.8">
                We’re thrilled to see you take part in the Band 8+ IELTS Speaking Masterclass Daily Usage Idioms and Phrases with UniSearch!
              </p>
              <p style="line-height: 1.8">
                Here at UniSearch, our top priority is making sure the right
                study abroad opportunities are accessible to each of our
                students. Our IELTS Academic Masterclasses are designed with
                this goal in mind. These one-hour crash-courses take a targeted
                approach to building up the very skills the IELTS evaluates you
                on, until you’re ready to hit your dream scores with ease!
              </p>
              <p style="line-height: 1.8">
                We look forward to seeing you in class on 19 MAY, 2022 10:00 to 11:00 AM.
              </p>
              <p style="line-height: 1.8">
                Please join the session through the link below:
              </p>
              <p>
                <a
                  href="https://zoom.us/j/94960983299?pwd=N093UkVZd0JoMXczbmdhdTl4cWJ6UT09#success"
                  target="_blank"
                  style="
                    padding: 10px 20px;
                    display: inline-block;
                    text-decoration: none;
                    border-radius: 6px;
                    background: #f47f20;
                    color: white;
                    cursor: pointer;
                  "
                >
                  Join Now
                </a>
              </p>
              <p style="line-height: 1.8">
              For further information, do reach out to us at <br />
              info@myunisearch.com +91 9717814894!
              </p>
              <p style="line-height: 1.8">
                See you soon! <br />
                UniSearch
              </p>
            </div>
        `}
      />
    </>
  );
};

export default DailyIdiomsPhrases;
